// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.part1, .part2 {
  width: 50%;
}

.part1 {
  background-color: lightsalmon;
}

mat-tab-group {
  width: 100% !important;
}
mat-tab-group ::ng-deep .mat-tab-body-wrapper {
  height: 100%;
}

.feedbacks-container {
  mix-blend-mode: normal;
  border: 1px solid #9B9B9B;
  box-sizing: border-box;
  padding-bottom: 17px;
  padding-top: 8px;
  margin-left: 10px;
  margin-right: 10px;
}

/*.mat-expansion-panel-header {
  height: 48px;
}
.mat-expansion-panel-content:not(.mat-expanded) {
  .mat-expansion-panel-body {
    padding-bottom: 0;
  }
}*/
.part2 {
  background-color: lightgoldenrodyellow;
}

.reading-grid, .feedbacks {
  float: left;
  cursor: pointer;
}

.logical-connectors {
  float: right;
  cursor: pointer;
}

.draft-text {
  width: 100%;
}

#section {
  position: relative;
  max-width: 100% !important;
  width: 100% !important;
}

textarea {
  mix-blend-mode: normal;
  box-sizing: border-box;
  resize: none;
  background: none;
  border: 0;
  width: 90%;
  min-height: 50px;
}

.section-separator div {
  height: 2px;
  background: red;
}
.section-separator span {
  color: #FF787D;
}

.close-button-icon {
  background: white;
  top: 5px;
  right: 10px;
  position: absolute;
  z-index: 2;
}

.input-container {
  padding-top: 50px;
  z-index: 9999;
}

.connector {
  cursor: pointer;
  height: 20px;
  display: inline-block;
  line-height: 18px;
  padding-left: 22px;
  padding-right: 22px;
  margin-right: 40px;
  margin-left: 0px;
  border: 1px solid #979797;
  box-sizing: border-box;
  border-radius: 14px;
  background: white;
  font-size: 10px;
  margin-bottom: 17px;
}

.logical-connector, .openings {
  text-align: center;
  margin-bottom: 15px;
}

.connector-container {
  border: 1px solid #9B9B9B;
  box-sizing: border-box;
  text-align: left;
  padding: 10px;
  padding-bottom: 0px;
}

.openers-title {
  font-size: 12px;
  margin-bottom: 13px;
}

.connector-title {
  margin-bottom: 20px;
  text-align: left;
  font-weight: bold;
}

label {
  font-weight: bold;
}

.save-button {
  background: #FF787D;
  box-shadow: 0px 1px 8px rgba(209, 209, 209, 0.5);
  border-radius: 17.5px;
  height: 35px;
  color: white;
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
  left: -25%;
  position: relative;
}
.save-button:disabled {
  opacity: 0.5;
}

.add-medias-button {
  background: #DFB900;
  box-shadow: 0px 1px 8px rgba(209, 209, 209, 0.5);
  border-radius: 17.5px;
  height: 25px;
  color: white;
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
}

.save-input-container {
  text-align: center;
  position: absolute;
  bottom: 13px;
  transform: translateX(-50%);
  left: 50%;
  z-index: 1;
}

.original-text {
  color: rgba(74, 74, 74, 0.5);
  white-space: pre-line;
}

.top-section {
  mix-blend-mode: normal;
  border: 1px solid #9B9B9B;
  box-sizing: border-box;
  padding-bottom: 17px;
  padding-top: 8px;
  margin-left: 10px;
  margin-right: 10px;
}

app-external-corpus-display {
  /*height: 100% !important;
  width: 100%;
  display: block;*/
}
app-external-corpus-display ::ng-deep #file-manager {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/research-sheet/core/section-draft-display/section-draft-edit/section-draft-edit.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,sBAAA;AACF;AAEI;EACE,YAAA;AAAN;;AAKA;EACE,sBAAA;EACA,yBAAA;EAEA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAFF;;AAKA;;;;;;;EAAA;AAgBA;EACE,sCAAA;AAVF;;AAaA;EACE,WAAA;EACA,eAAA;AAVF;;AAaA;EACE,YAAA;EACA,eAAA;AAVF;;AAaA;EACE,WAAA;AAVF;;AAcA;EACE,kBAAA;EACA,0BAAA;EACA,sBAAA;AAXF;;AAcA;EAEE,sBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAZF;;AAgBE;EACE,WAAA;EACA,eAAA;AAbJ;AAeE;EACE,cAAA;AAbJ;;AAiBA;EACE,iBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AAdF;;AAiBA;EACE,iBAAA;EACA,aAAA;AAdF;;AAkBA;EACE,eAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAfF;;AAkBA;EACE,iBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,gDAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AAfF;AAiBE;EACE,YAAA;AAfJ;;AAmBA;EACE,mBAAA;EACA,gDAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,SAAA;EACA,UAAA;AAhBF;;AAmBA;EACE,4BAAA;EACA,qBAAA;AAhBF;;AAmBA;EACE,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAhBF;;AAwBA;EACE;;kBAAA;AAnBF;AAwBI;EACE,YAAA;AAtBN","sourcesContent":[".part1, .part2 {\n  width: 50%;\n}\n\n.part1 {\n  background-color: lightsalmon;\n}\n\nmat-tab-group {\n  width: 100% !important;\n\n  ::ng-deep {\n    .mat-tab-body-wrapper {\n      height: 100%;\n    }\n  }\n}\n\n.feedbacks-container {\n  mix-blend-mode: normal;\n  border: 1px solid #9B9B9B;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  padding-bottom: 17px;\n  padding-top: 8px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n/*.mat-expansion-panel-header {\n  height: 48px;\n}\n.mat-expansion-panel-content:not(.mat-expanded) {\n  .mat-expansion-panel-body {\n    padding-bottom: 0;\n  }\n}*/\n\n::ng-deep {\n  .mat-expansion-panel-content {\n    //height: 0px;\n    //visibility: hidden;\n  }\n}\n\n.part2 {\n  background-color: lightgoldenrodyellow;\n}\n\n.reading-grid, .feedbacks {\n  float: left;\n  cursor: pointer;\n}\n\n.logical-connectors {\n  float: right;\n  cursor: pointer;\n}\n\n.draft-text {\n  width: 100%;\n  // height: 150px;\n}\n\n#section {\n  position: relative;\n  max-width: 100% !important;\n  width: 100% !important;\n}\n\ntextarea {\n  // height: 150px;\n  mix-blend-mode: normal;\n  box-sizing: border-box;\n  resize: none;\n  background: none;\n  border: 0;\n  width: 90%;\n  min-height: 50px;\n}\n\n.section-separator{\n  div{\n    height: 2px;\n    background: red;\n  }\n  span{\n    color: #FF787D;\n  }\n}\n\n.close-button-icon {\n  background: white;\n  top: 5px;\n  right: 10px;\n  position: absolute;\n  z-index: 2;\n}\n\n.input-container {\n  padding-top: 50px;\n  z-index: 9999;\n\n}\n\n.connector {\n  cursor: pointer;\n  height: 20px;\n  display: inline-block;\n  line-height: 18px;\n  padding-left: 22px;\n  padding-right: 22px;\n  margin-right: 40px;\n  margin-left: 0px;\n  border: 1px solid #979797;\n  box-sizing: border-box;\n  border-radius: 14px;\n  background: white;\n  font-size: 10px;\n  margin-bottom: 17px;\n}\n\n.logical-connector, .openings {\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n.connector-container {\n  border: 1px solid #9B9B9B;\n  box-sizing: border-box;\n  text-align: left;\n  padding: 10px;\n  padding-bottom: 0px;\n}\n\n.openers-title {\n  font-size: 12px;\n  margin-bottom: 13px;\n}\n\n.connector-title {\n  margin-bottom: 20px;\n  text-align: left;\n  font-weight: bold;\n}\n\nlabel {\n  font-weight: bold;\n}\n\n.save-button {\n  background: #FF787D;\n  box-shadow: 0px 1px 8px rgba(209, 209, 209, 0.5);\n  border-radius: 17.5px;\n  height: 35px;\n  color: white;\n  padding-left: 20px;\n  padding-right: 20px;\n  cursor: pointer;\n  left: -25%;\n  position: relative;\n\n  &:disabled {\n    opacity: 0.5;\n  }\n}\n\n.add-medias-button {\n  background: #DFB900;\n  box-shadow: 0px 1px 8px rgba(209, 209, 209, 0.5);\n  border-radius: 17.5px;\n  height: 25px;\n  color: white;\n  padding-left: 20px;\n  padding-right: 20px;\n  cursor: pointer;\n}\n\n.save-input-container {\n  text-align: center;\n  position: absolute;\n  bottom: 13px;\n  transform: translateX(-50%);\n  left: 50%;\n  z-index: 1;\n}\n\n.original-text {\n  color: rgba(74, 74, 74, 0.5);\n  white-space: pre-line;\n}\n\n.top-section {\n  mix-blend-mode: normal;\n  border: 1px solid #9B9B9B;\n  box-sizing: border-box;\n  padding-bottom: 17px;\n  padding-top: 8px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\nmat-tab {\n  // width: 100% !important;\n}\n\n\napp-external-corpus-display {\n  /*height: 100% !important;\n  width: 100%;\n  display: block;*/\n\n  ::ng-deep {\n    #file-manager {\n      height: 100%;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
